import React, { useState, useRef, FC, PropsWithChildren } from 'react';
import { path, pathOr } from 'ramda';
import { useTranslations } from '@lang';
import { OpenIndicator } from '../index';
import {
  MoreInfoBoxWrapper,
  ControlsBox,
  ToggleMoreInfo,
  ControlsWrapper,
} from './MoreInfoBox.styles';

const ICON_SIZE = 24;

export const MoreInfoBox: FC<PropsWithChildren> = ({ children }) => {
  const { t } = useTranslations();
  const [isOpen, setIsOpen] = useState(false);
  const descriptionRef = useRef(null);
  const descriptionElement = path(['current'], descriptionRef);
  const descriptionHeight = pathOr(0, ['children', '0', 'clientHeight'], descriptionElement);

  return (
    <MoreInfoBoxWrapper>
      <ToggleMoreInfo
        onClick={(e) => {
          e.preventDefault();
          setIsOpen(!isOpen);
        }}
      >
        <span>{t('room.moreInfo')}</span>
        <OpenIndicator width={ICON_SIZE} height={ICON_SIZE} $isOpen={isOpen} />
      </ToggleMoreInfo>
      <ControlsBox isOpen={isOpen} ref={descriptionRef} descriptionHeight={descriptionHeight}>
        <ControlsWrapper isOpen={isOpen}>{children}</ControlsWrapper>
      </ControlsBox>
    </MoreInfoBoxWrapper>
  );
};
